import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = [
  {
    order: 0,
    module: "Work Order",
    moduleFileType: "signature.png",
  }
];

const workOrderApis = {
  getWorkOrderList: (params: any) =>
    makeApiCall({
      url: `/work-order/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkOrderList: (params: any) =>
    makeApiCall({
      url: `/work-order/pending-approvals`,
      method: "get",
      params,
    }),
  createWorkOrder: (data: any) =>
    makeApiCall({
      url: `/work-order/create`,
      method: "post",
      data,
    }),
  getWorkOrderById: (workOrderId: any) =>
    makeApiCall({
      url: `/work-order/id/${workOrderId}`,
      method: "get",
    }),
  updateWorkOrder: (data: any) =>
    makeApiCall({
      url: `/work-order/update`,
      method: "put",
      data,
    }),
  releaseWorkOrder: (data: any) =>
    makeApiCall({
      url: `/work-order/release`,
      method: "post",
      data,
    }),
  approveWorkOrder: (workOrderId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      workOrderId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("workOrderApproval", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/work-order/approve`,
      data: formData,
    });
  },

  rejectWorkOrder: (workOrderId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      workOrderId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("workOrderReject", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "post",
      url: `/work-order/reject`,
      data: formData,
    });
  },

  completeWorkOrder: (data: any) =>
    makeApiCall({
      url: "/work-order/complete",
      method: "post",
      data,
    }),
  submitRiskFlags: (data: any) =>
    makeApiCall({
      url: "/work-order/risk-flags/submit",
      method: "post",
      data,
    }),
};

export default workOrderApis;
